<template>
    <b-button
        :variant="variant"
        block
        @click="$router.go(-1)"
    >
        {{ $t('main.return') }}
    </b-button>
</template>

<script>
export default {
    name: 'ReturnButton',
    props: {
        variant: {
            type: String,
            'default': 'light',
        },
    },
};
</script>